<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail input-scan-page" @hidden="resetModal" scrollable
		:no-close-on-backdrop=true @ok="addButtonAction" title="Part Good Receipt">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
					<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''"
						label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
						<app-label label-cols-lg="12" size="sm" label="Part" :isRequired="true"
						:model="model.part != null ? model.part.partNameCombination : ''" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-scan id="fieldset-supplier-case-number" ref="fieldset-supplier-case-number"
						label="Supplier Case Number" :model.sync="model.supplierCaseNumber" :isRequired="true"
						:state="validateState('supplierCaseNumber')" @scannedMethod="changeFocus('CASE_NUMBER')"
						:errorMessage="getErrorMessage(errorMessage.supplierCaseNumber, 'supplierCaseNumber')"
						:isBusy="isScanSupplierCaseNumberLoading" autofocus />
					<app-input-textbox-custom id="fieldsetQtyPo" ref="fieldsetQtyPo" label-cols-lg="12" :label="'Qty ' + uomName"
							label-for="input-qty-Po" size="sm" :model.sync="model.qtyPo" :isRequired="true"
							:decimalSeparator="true"   @enterMethod="changeFocus('QTY_KG')" />
					<app-input-textbox-custom id="fieldsetqtyActual" ref="fieldsetqtyActual" label-cols-lg="12" :label="'Qty ' + uomName2"
						label-for="input-qty-sheet" size="sm" :model.sync="model.qtyActual" :isRequired="true"
						:decimalSeparator="true" @enterMethod="changeFocus('QTY_SHEET')"
						v-if="!isSameUom" />
				</b-col>
				<b-col cols="12" lg="6">
				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
			<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
			<b-overlay :show="isBusy" rounded opacity="0.6" spinner-small spinner-variant="primary"
				class="float-right ">
				<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
					Save
				</b-button>
			</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
::v-deep .modal-dialog {
	width: 70% !important;
}

@media (max-width: 576px) {
	::v-deep .modal-dialog {
		width: calc(100%) !important;
	}
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import focusInput from '@/mixins/focusInputMixin';
import PartGoodReceiptCase from '@/models/PartGoodReceipt/PartGoodReceiptCase';
import PartGoodReceiptCaseFilter from '@/filters/PartGoodReceipt/PartGoodReceiptCaseFilter';

import PartGoodReceipt from '@/models/PartGoodReceipt/PartGoodReceipt';
import PartGoodReceiptFilter from '@/filters/PartGoodReceipt/PartGoodReceiptFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextboxCustom from '@/components/AppInputTextboxCustom';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import PartGoodReceiptDetail from '@/models/PartGoodReceipt/PartGoodReceiptDetail';
import PartGoodReceiptDetailFilter from '@/filters/PartGoodReceipt/PartGoodReceiptDetailFilter';
import PopupRouterView from '@/components/PopupRouterView';
import AppInputScan from '@/components/AppInputScan';
import AppLabel from '@/components/AppLabel';

export default {
	props: ['model', 'modelId', 'openPopup', 'addButtonMethod', 'resetMethod', 'parentLabelInfo', 'parentValueInfo'],
	components: {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterView,
		AppInputScan,
		AppLabel,
		AppInputTextboxCustom,
	},
	mixins: [validationMixin, focusInput],
	validations: {
		model: {
			supplierCaseNumber: { required },
		}
	},
	data() {
		return {
			errorMessage: {
				supplierCaseNumber: { required: "Supplier Case Number is Required." },
			},
			parts: [],
			controlCards: [],
			isBusy: false,
			isScanSupplierCaseNumberLoading: false,
			uomName: '',
			uomName2: '',
			isSameUom: false,
		}
	},
	methods: {
		checkUoms: function(obj) {
			if(obj == null || obj == undefined || obj.part == null || obj.part == undefined) return;
			console.log("uom", obj.part.uom);
			console.log("uomPo", obj.part.uomPo);
			if(obj.part.uomCode == obj.part.uomPoCode) {
				this.uomName = obj.part.uomCode;
				this.uomName2 = obj.part.uomCode;
				this.isSameUom = true;
			} else {
				this.uomName = obj.part.uomPoCode;
				this.uomName2 = obj.part.uomCode;
				this.isSameUom = false;
			}
		},
		changeFocus: function(prefix) {
			switch (prefix) {
				case "CASE_NUMBER":
					let qrCode = decodeURIComponent(this.model.supplierCaseNumber);
					this.model.supplierCaseNumber = qrCode;
					this.focusInput(this,'fieldsetQtyPo');
					break;
				case "QTY_PO":
					this.focusInput(this,'fieldsetqtyActual');
					break;
				default:
					break;
			}
		},
		getPartGoodReceiptCase: async function (id) {
			this.isBusy = true;
			PartGoodReceiptCase.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
				})
				.catch(error => { });
		},
		getControlCards: async function (input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.controlCards = result.data
					}
				})
				.catch(error => { });
		},
		getPartGoodReceiptDetails: async function (input) {
			let filter = new PartGoodReceiptDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			PartGoodReceiptDetail.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.partGoodReceiptDetails = result.data
					}
				})
				.catch(error => { });
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				let promises = Array();
				let _this = this;
				var valuePo = parseFloat(this.model.valuePo);
				if (this.model.qtyOutstandingBefore == null) {
					this.model.qtyOutstandingBefore = 0;
				}
				var valueOutstanding = parseFloat(this.model.qtyOutstandingBefore.toString());

				if (this.model.qtyOutstandingAfter) {
					valueOutstanding = parseFloat(this.model.qtyOutstandingAfter);
				}

				if (valuePo > valueOutstanding) {
					const msg = this.$createElement;
					let msgNode = '';
					msgNode = msg('div', { domProps: { innerHTML: '<p>Qty Po melebihi sisa Qty Outstanding, apakah anda ingin melanjutkan?</p>' } })
					this.$bvModal.msgBoxConfirm([msgNode], {
						title: 'Alert',
						size: 'sm',
						buttonSize: 'sm',
						okVariant: 'success',
						cancelVariant: 'secondary',
						okTitle: 'Yes',
						cancelTitle: 'No',
						footerClass: 'p-2',
						hideHeaderClose: false,
						centered: true
					}).then(e => {
						if (e) {
							Promise.all(promises).then((results) => {
								_this.$emit("addButtonMethod", modalEvent, _this.model);
							});

							this.$nextTick(() => { this.$v.$reset() })
						} else {
							return;
						}
					});
				} else {
					Promise.all(promises).then((results) => {
						_this.$emit("addButtonMethod", modalEvent, _this.model);
					});

					this.$nextTick(() => { this.$v.$reset() })

				}

			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	}, beforeMount() {
		//this.getParts();
		//this.getControlCards();
		//this.getPartGoodReceiptDetails();
	},
	async mounted() {
	},
	created() {
		console.log("case scan", this.model);
		this.checkUoms(this.model);
	},
	watch: {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPartGoodReceiptCase(newValue);
			} else {
				this.model = {};
			}
		},
		model(newValue) {
			this.checkUoms(newValue);
		},
		openPopup(newValue) {
			if (newValue) {
				//this.getPurchaseOrderDetails();
				this.getParts();
				//this.getControlCards();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getPartGoodReceiptCase(this.modelId);
				}
			}
			// else {
			// 	this.model = {};
			// }
		}
	},
	computed: {
		isShowPopup: {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) { }
		},
	}
}
</script>
